import Typography from "Components/CommonComponents/Typography";
import LeftArrow from "Assets/Icons/LeftArrow";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";

interface TitleProps {
  onBack: () => void;
}

const Title = ({ onBack }: TitleProps) => {
  const { screen }: any = useWindowSize();

  return (
    <div className="d-flex align-items-center w-100 pl-2">
      <LeftArrow className={"cursorHoverCSS mr-1"} onClick={onBack} />
      <Typography
        variant={["xxl", "xl"].includes(screen) ? "h4" : "h6"}
        color="black"
      >
        My Schedule
      </Typography>
    </div>
  );
};

export default Title;
